var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{style:('color:' + (
  _vm.log.errorMessages && _vm.log.errorMessages.length > 0 ? '#D32F2F' : (
    _vm.log.warningMessages && _vm.log.warningMessages.length > 0 ? '#FFA000' : '#26a73a'
  )
))},[_c('td',[_vm._v(_vm._s((_vm.log.errorMessages && _vm.log.errorMessages.length > 0 ? 'nein' : 'ja')))]),_c('td',[_vm._v(_vm._s(_vm.log.name))]),_c('td',[_vm._v(_vm._s(_vm.log.errorMessages))]),_c('td',[_vm._v(_vm._s(_vm.log.warningMessages))])])}
var staticRenderFns = []

export { render, staticRenderFns }